export default __webpack_public_path__ + "static/media/03.374a131b.png";